// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import actions from '../actions';
import ImmersiveOutcomesList from '../components/ImmersiveOutcomesList';
import { outcomesListSelector } from '../selectors/outcomesList';

type ImmersiveOutcomesListContainerProps = {
  className?: string;
  matchId: number;
};

const ImmersiveOutcomesListContainer = ({ matchId, ...ownProps }: ImmersiveOutcomesListContainerProps) => {
  const dispatch = useDispatch();
  const selectorProps = useMemo(() => ({ matchId }), [matchId]);
  const selectedProps = useSelector((state) => outcomesListSelector(state, selectorProps));

  const onClickOutcome = useCallback(
    (payload) => {
      dispatch(actions.addItem(payload));
    },
    [dispatch],
  );

  const onSelectChange = useCallback(
    (payload) => {
      dispatch(actions.setSelectedBetGroupId(payload));
    },
    [dispatch],
  );

  const otherProps = useMemo(
    () => ({
      onClickOutcome,
      onSelectChange,
    }),
    [onClickOutcome, onSelectChange],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <ImmersiveOutcomesList {...enhancedProps} />;
};

export default ImmersiveOutcomesListContainer;
